import React, { Fragment } from "react";
import { IconButton, Menu, MenuItem, IconButtonProps } from "@material-ui/core";
import MoreIcon from "@material-ui/icons/MoreHoriz";

interface IProps extends IconButtonProps {
  rowData?: any;
  menuItems?: Array<string>;
  menuItemSelectedHandler?: (
    menuItem: string,
    index: number,
    rowData?: any
  ) => void;
}

export default function MoreButton(props: IProps) {
  const { rowData, menuItems, menuItemSelectedHandler, ...other } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  function closeMenu(event: any) {
    event?.stopPropagation();
    setAnchorEl(null);
  }

  function clickHandler(menuItem: string, index: number) {
    if (props.menuItemSelectedHandler) {
      props.menuItemSelectedHandler(menuItem, index, props.rowData);
    }
    closeMenu(null);
  }

  return (
    <Fragment>
      <IconButton
        onClick={event => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
        aria-controls="simple-menu"
        aria-haspopup="true"
        {...other}
      >
        <MoreIcon />
      </IconButton>
      <Menu
        className="row-menu"
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={closeMenu}
      >
        {props.menuItems &&
          props.menuItems.map((menuItem, index) => (
            <MenuItem
              onClick={event => {
                event.stopPropagation();
                clickHandler(menuItem, index);
              }}
              key={index}
            >
              {menuItem}
            </MenuItem>
          ))}
      </Menu>
    </Fragment>
  );
}
